import React, { Component } from "react";
import axios from "axios";
import { Segment, Image, Grid, Statistic } from "semantic-ui-react";
import order from "../images/dashboard/list.svg"

export default class OrdersCountDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
        orders: [],
        loading: true
        };
    }  

    getOrdersByToken = (userid, user_type) => {
        const findPipe = userid.indexOf("|");
        const id = userid.substr(findPipe+1);
        let url = user_type === "ADMIN" ? 'https://api.dontwaste.me/orders/' : `https://api.dontwaste.me/orders/purchases/accounts/${id}`
        if (this.state.loading) {
            axios.get(`${url}`, {})
                .then(orders => { this.setState({ orders: orders.data.orders, loading: false }) })
                .catch(err => {console.log(err);});
        }
    };

    render() {
        return (
            <Grid.Column width={3} data={this.getOrdersByToken(this.props.userid, this.props.user_type)}>
                <Segment placeholder raised>
                    <Statistic>
                        <Statistic.Label><Image src={order} size="mini"/></Statistic.Label>
                        
                                <Statistic.Value>{this.state.orders.length}</Statistic.Value>
                        
                        <Statistic.Label>{this.props.dashboard_box_orders}</Statistic.Label>
                    </Statistic>
                </Segment>
            </Grid.Column>
        );
    }
    }
